<template>
	<router-view />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { client } from '@/api/client';

export default {
	computed: {
		...mapState(['pageTitle']),
		...mapState("kiriminaja", ["siteConfig"]),
		title() {
			return `${this.pageTitle}`;
		},
	},
	watch: {
		pageTitle(val, oldVal) {
			if (val !== oldVal) {
				document.title = this.title;
			}
		},
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapActions("kiriminaja", ["getSiteConfig"]),
		forceLogout() {
			this.logout().then(() => {
				this.$router.push({ name: 'login', query: { redirect: this.$route.fullPath } }).catch(() => { });
			});
		},
		async renderGAScript(gaKey) {
			let head = document.getElementsByTagName("head")[0];
			var myScript = document.createElement('script');
			myScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + gaKey);
			myScript.onload = async function () {
				window.dataLayer = window.dataLayer || [];
				async function gtag() { dataLayer.push(arguments); }
				gtag('js', new Date());
				// console.log('window.dataLayer Executed',gaKey, window.dataLayer)
				gtag('config', gaKey);
			}
			head.insertBefore(myScript, head.children[1]);
			// console.log("GA-" + gaKey)
		},
		async renderFBPixelScript(fbPixelKey) {
			let headFB = document.getElementsByTagName("head")[0];
			var myFBScript = document.createElement('script');
			myFBScript.onload = function () {
				!function (f, b, e, v, n, t, s) {
					if (f.fbq) return; n = f.fbq = function () {
						n.callMethod ?
							n.callMethod.apply(n, arguments) : n.queue.push(arguments)
					};
					if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
					n.queue = []; t = b.createElement(e); t.async = !0;
					t.src = v; s = b.getElementsByTagName(e)[0];
					s.parentNode.insertBefore(t, s)
				}(window, document, 'script',
					'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', fbPixelKey);
				fbq('track', 'PageView');
			}
			headFB.insertBefore(myFBScript, headFB.children[1]);
		}
	},
	async beforeMount() {
		// await this.getSiteConfig();
		// console.log("siteconf", this.siteConfig.favicon)
		var link =
			(await document.querySelector("link[rel*='icon']")) ||
			document.createElement("link");
		link.type = await "image/x-icon";
		link.rel = await "shortcut icon";
		link.href = await this.siteConfig.favicon;
		await document.getElementsByTagName("head")[0].appendChild(link);


	},
	async beforeCreate() {
		await this.$store.dispatch("kiriminaja/getSiteConfig");
		var that = this;
		if (this.siteConfig.ga_key != '') {
			setTimeout(function () {
				that.renderGAScript(that.siteConfig.ga_key)
			}, 1000)
		}

		if (this.siteConfig.fb_pixel_key != '') {
			setTimeout(function () {
				that.renderFBPixelScript(that.siteConfig.fb_pixel_key)
			}, 1000)
		}
	},
	created() {
		client.interceptors.response.use(undefined, (error) => {
			return new Promise(() => {
				if (error.response.status === 406) {
					this.forceLogout();
				}
				throw error;
			});
		});
	},
};
</script>

<style lang="scss">
@import "./styles/theme";
@import "./styles/page";
@import "./styles/responsive";
</style>